
<h2 mat-dialog-title>
  {{ bookingOption.title }}
</h2>

@if (easFormGroup$ | async; as easFormGroup) {
  <mat-dialog-content>
    <div>
      @if (state$ | async; as state) {
        <ub-label variant="none" [text]="state.name"></ub-label>
      }
      <a mat-button target="_blank" [routerLink]="['bookings', booking.id, 'edit']">
        <mat-icon>open_in_new</mat-icon> <span i18n>Open in a new tab</span>
      </a>
    </div>
    <form [formGroup]="easFormGroup.control">
      <div class="form-container">
        <eas-easform-group [easGroup]="easFormGroup"></eas-easform-group>
      </div>
    </form>
  </mat-dialog-content>
}

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" i18n>Cancel</button>
</mat-dialog-actions>
